import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@material-ui/core'

import { useIsOnline } from 'commons/useIsOnline'
import NetworkError from 'app/components/NetworkError'
import LargeToolbar from 'app/components/LargeToolbar'
import ContentToolbarPage from 'app/components/ContentToolbarPage'

import Content from './Content'

function UsageSummary({ location }) {
  const [isOnline] = useIsOnline()

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => {}} />
  }
  return (
    <ContentToolbarPage
      contentToolbar={
        <LargeToolbar
          content={
            <>
              <Typography variant="h6">
                <FormattedMessage id="navigation.planAndBilling.usageSummary.label" />
              </Typography>
            </>
          }
        />
      }
      content={<Content />}
    />
  )
}

export default UsageSummary
